module.exports = __webpack_public_path__ + "static/media/400277_01.98f6e1d0.png";